import { AutogenModelServiceTransitTime, AutogenRowServiceTransitTime } from "./autogen/AutogenModelServiceTransitTime";

export class ModelServiceTransitTime extends AutogenModelServiceTransitTime<RowServiceTransitTime> {
	constructor() {
		super(RowServiceTransitTime);
	}
}

export class RowServiceTransitTime extends AutogenRowServiceTransitTime {
}